const API_CONFIG = {
  MOCK: process.env.REACT_APP_MOCK === 'true',
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/v1',
  TIMEOUT: 15000,   // 15s — Vercel cold starts can take ~3-5s
  MOCK_DELAY: 300,
};

export default API_CONFIG;
